Controller.$inject = [];

function Controller() {

}

export function HuiTbody() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {},
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
               <tbody ng-transclude></tbody>
            `;
        }
    }
}